// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/start_shift.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.StartShiftRequest
 */
export class StartShiftRequest extends Message<StartShiftRequest> {
  /**
   * @generated from field: float cash_drawer_start_amount = 1;
   */
  cashDrawerStartAmount = 0;

  /**
   * @generated from field: float card_start_amount = 2;
   */
  cardStartAmount = 0;

  /**
   * @generated from field: string shift_name = 3;
   */
  shiftName = "";

  /**
   * @generated from field: string cash_register_id = 4;
   */
  cashRegisterId = "";

  /**
   * @generated from field: int32 start_time = 5;
   */
  startTime = 0;

  constructor(data?: PartialMessage<StartShiftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StartShiftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cash_drawer_start_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "card_start_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "shift_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cash_register_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start_time", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartShiftRequest {
    return new StartShiftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartShiftRequest {
    return new StartShiftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartShiftRequest {
    return new StartShiftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartShiftRequest | PlainMessage<StartShiftRequest> | undefined, b: StartShiftRequest | PlainMessage<StartShiftRequest> | undefined): boolean {
    return proto3.util.equals(StartShiftRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StartShiftResponse
 */
export class StartShiftResponse extends Message<StartShiftResponse> {
  constructor(data?: PartialMessage<StartShiftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StartShiftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartShiftResponse {
    return new StartShiftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartShiftResponse {
    return new StartShiftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartShiftResponse {
    return new StartShiftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartShiftResponse | PlainMessage<StartShiftResponse> | undefined, b: StartShiftResponse | PlainMessage<StartShiftResponse> | undefined): boolean {
    return proto3.util.equals(StartShiftResponse, a, b);
  }
}

